<mat-card fxFlex.sm="0 0 100%" fxFlex.md="0 0 100%" fxFlex.gt-md="0 0 100%" [ngClass]="{matcardextra: fxShowxs}" [ngClass]="{matcardnopadding: !fxShowxs}" style="width: 100%">
  <mat-card-content>
    <div class="fade-in project-list-entry" [ngClass]="{selected: selected}" [ngClass]="{selected: (0 === index % 2) && (fxShowxs || fxShowsm || fxShowmd)}" (click)="select()">

      <div class="row col-12 searchlabel">
        <div class="col-4 bold" i18n>Zeitraum</div>
        <div class="col-4 bold" i18n>von</div>
        <div class="col-4 bold" i18n>bis</div>
      </div>
      <div class="row col-12">
        <div class="col-4"></div>
        <div class="col-4">{{project.beginn | date:'mediumDate':locale }}</div>
        <div class="col-4">{{project.end | date:'mediumDate':locale }}</div>
      </div>

      <div class="row col-12 searchlabel">
        <div class="col-4 bold" i18n>Firmenname</div>
        <div class="col-4 bold" i18n></div>
        <div class="col-4 bold" i18n></div>
      </div>
      <div class="row col-12">
        <div class="col-12">{{project.company_name}}</div>
      </div>

      <div class="row col-12 searchlabel">
        <div class="col-12 bold" i18n>Projekt</div>
      </div>
      <div class="row col-12">
        <div class="col-12">{{project.name}}</div>
      </div>

      <div class="row col-12 searchlabel">
        <div class="col-4 bold" i18n>Beschreibung</div>
        <div class="col-4 bold" i18n></div>
        <div class="col-4 bold" i18n></div>
      </div>
      <div class="row col-12">
        <div class="col-12">{{project.description}}</div>
      </div>

      <div class="row col-12 searchlabel">
        <div class="col-4 bold" i18n>eingesetzte Software</div>
        <div class="col-4 bold" i18n></div>
        <div class="col-4 bold" i18n></div>
      </div>
      <div class="row col-12">
        <div class="col-12" *ngFor="let software of project.software; let index = index"
        >{{software.name}}</div>
      </div>

    </div>
  </mat-card-content>
</mat-card>
